import React from "react";
import { CheckCircle, XCircle, AlertTriangle } from "lucide-react";

const statusIcon = {
  ok: <CheckCircle className="w-5 h-5 text-green-400" />,
  error: <XCircle className="w-5 h-5 text-red-400" />,
  degraded: <AlertTriangle className="w-5 h-5 text-amber-400" />,
};

const statusBg = {
  ok: "bg-green-900/20 border-green-800/30",
  error: "bg-red-900/20 border-red-800/30",
  degraded: "bg-amber-900/20 border-amber-800/30",
};

export default function ServiceStatusPanel({ services }) {
  if (!services || services.length === 0) {
    return (
      <div className="text-gray-500 text-sm py-8 text-center">
        No service checks recorded yet. They run daily at 7 AM.
      </div>
    );
  }

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
      {services.map((svc) => (
        <div
          key={svc.id}
          className={`rounded-xl border p-4 ${statusBg[svc.status] || "bg-dark-300 border-dark-50"}`}
        >
          <div className="flex items-center gap-2 mb-2">
            {statusIcon[svc.status] || statusIcon.error}
            <span className="font-medium text-sm">
              {svc.service_name}
              {svc.website_domain ? ` (${svc.website_domain})` : ""}
            </span>
          </div>
          <div className="text-xs text-gray-400 truncate" title={svc.detail}>
            {svc.detail || "—"}
          </div>
          <div className="text-xs text-gray-600 mt-1">
            {svc.response_ms != null ? `${svc.response_ms}ms` : ""}
            {svc.checked_at
              ? ` · ${new Date(svc.checked_at).toLocaleString()}`
              : ""}
          </div>
        </div>
      ))}
    </div>
  );
}
